import React from "react";
import ForfeitureReportContainer from "../../../containers/ReportsContainer/ForfeitureReportContainer";

const ForfeitureReport = (props) => {
  return <ForfeitureReportContainer {...props} />;
};

export default ForfeitureReport;
